module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Underdog-2007.aeb1a4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Underdog-2007.jpg
// module id = yRh/
// module chunks = 0